import './App.css';
import { Grid } from '@mui/material';
import LoginScanApp from './pages/login';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import TicketScan from './pages/ticket-scan';
import ModuleSelect from './pages/module-select';
import ScanAppHeader from './components/header';
import { useState } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

function App() {
  const [token, setToken] = useState('');

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
      },
    },
  });

  if (!token) {
    return <LoginScanApp token={token} setToken={setToken} />;
  }

  return (
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <div className="App">
          <ScanAppHeader />
          <Grid item xs={9} md={10}>
            <Routes>
              <Route path="/" element={<ModuleSelect token={token} />} />
              <Route
                path="/:scanModuleId"
                element={<TicketScan token={token} />}
              />
            </Routes>
          </Grid>
        </div>
      </QueryClientProvider>
    </BrowserRouter>
  );
}

export default App;
